export interface SmsNotificationSettings {
  isDiaryAnnouncementNotificationsEnabled: boolean;
  isEvaluationSummaryEnabled: boolean;
}

export interface EmailNotificationSettings {
  isDiaryAnnouncementNotificationsEnabled: boolean;
  isEvaluationSummaryEnabled: boolean;
  isCommunicationNotificationsEnabled: boolean;
  isIncomingMailMarkedAsRead: boolean;
}

export interface PushNotificationSettings {
  isDiaryAnnouncementNotificationsEnabled: boolean;
  isBehaviorEntryNotificationsEnabled: boolean;
  isEvaluationNotificationsEnabled: boolean;
  isNonAttendanceNotificationsEnabled: boolean;
  isHomeTaskNotificationsEnabled: boolean;
  isCommunicationNotificationsEnabled: boolean;
}

export interface NotificationSettingsResponse {
  sms: SmsNotificationSettings;
  email: EmailNotificationSettings;
  pushNotifications: PushNotificationSettings;
}

export enum NotificationChannel {
  Sms = 'sms',
  Email = 'email',
  Push = 'push',
}
